import React from "react";
import NnSongMenu from "./NnSongMenu"
import {
  Button,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  // NavLink,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from "reactstrap";
import { NavLink } from "react-router-dom";

class NnNavBar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Navbar light expand={false}>
        <NavbarBrand href="/">Numbered Notes</NavbarBrand>
        <Nav pills className="ml-auto">
          <NavItem>
              <NnSongMenu/>
          </NavItem>
          <NavItem>
            <Button color="primary" onClick={this.props.onPlaySong}>
              {"Play Song"}
            </Button>
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}

export default NnNavBar;



// WEBPACK FOOTER //
// ./src/NnNavBar.js